// src/InvoiceChecker.js
import { useEffect, useState } from 'react';
import { registerServiceWorkerAndSubscribe } from './push-utils';
import HttpService from "./Portal/Services/HttpService";

// جای اینجا کلید عمومی VAPID رو بذار (که از سرور تولید می‌کنی)
const VAPID_PUBLIC_KEY = 'BOaBnr4mTibVDWxkwf2tI61FDSCyBTS7hIeDRzht9n-i4cKjucahlN_tDK2tyYHAjor7QL1y20Y8K5pXQoG_NxA';

export default function InvoiceChecker() {
    const [subscribed, setSubscribed] = useState(false);
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        // ثبت subscription و ارسال به سرور
        const initPush = async () => {
            try {
                const sub = await registerServiceWorkerAndSubscribe(VAPID_PUBLIC_KEY);
                // ارسال به سرور برای ذخیره
                await HttpService.post('Push/Subscribe', sub);
                console.log('Subscribed and saved on server.');
                setSubscribed(true);
            } catch (err) {
                console.warn('Push subscription failed:', err.message || err);
            }
        };

        // فقط یکبار اجرا
        initPush();
    }, []);

    // این بخش اختیاریه: اگر می‌خوای همچنان polling داشته باشی وقتی تب باز است:
    // useEffect(() => {
    //     let mounted = true;
    //     const fetchLoop = async () => {
    //         try {
    //             const res = await HttpService.get('Api/Invoices');
    //             if (res.status === 200) {
    //                 if (!Array.isArray(invoices) || res.data.length !== invoices.length) {
    //                     setInvoices(res.data);
    //                     // اگر تب در پشت زمینه است، به خاطر redundancy هم نوتیف نشان میده (ولی نه ضروری)
    //                     if (document.visibilityState === 'hidden') {
    //                         if (Notification.permission === 'granted') {
    //                             new Notification('فاکتور جدید', { body: 'یک فاکتور جدید اضافه شد.' });
    //                         }
    //                     }
    //                 }
    //             }
    //         } catch (e) {
    //             // ignore
    //         } finally {
    //             if (mounted) setTimeout(fetchLoop, 10000);
    //         }
    //     };
    //     fetchLoop();
    //     return () => { mounted = false; };
    // }, [invoices]);

    return null; // هیچ UI لازم نیست
}
